import {
  toCharArray32huqyw9tt7kx as toCharArray,
  decodeToString1x4faah2liw2p as decodeToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  copyOfRange3alro60z4hhf8 as copyOfRange,
  contentEquals1cdp6c846cfdi as contentEquals,
  contentHashCode25jw6rgkgywwr as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.EMPTY_1 = ByteString().new_kotlinx_io_bytestring_ByteString_hfw4dq_k$(new Int8Array(0), null);
        this.HEX_DIGITS_1 = toCharArray('0123456789abcdef');
      }
      wrap_yhiemk_k$(byteArray) {
        return ByteString().new_kotlinx_io_bytestring_ByteString_hfw4dq_k$(byteArray, null);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ByteStringClass;
function ByteString() {
  if (ByteStringClass === VOID) {
    class $ {
      constructor(data, dummy) {
        return new.target.new_kotlinx_io_bytestring_ByteString_hfw4dq_k$(data, dummy);
      }
      static new_kotlinx_io_bytestring_ByteString_hfw4dq_k$(data, dummy) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.data_1 = data;
        $this.hashCode_2 = 0;
        return $this;
      }
      static new_kotlinx_io_bytestring_ByteString_507kaj_k$(data, startIndex, endIndex) {
        Companion_getInstance();
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? data.length : endIndex;
        return this.new_kotlinx_io_bytestring_ByteString_hfw4dq_k$(copyOfRange(data, startIndex, endIndex), null);
      }
      get_size_woubt6_k$() {
        return this.data_1.length;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof ByteString()))
          THROW_CCE();
        if (!(other.data_1.length === this.data_1.length))
          return false;
        if (!(other.hashCode_2 === 0) && !(this.hashCode_2 === 0) && !(other.hashCode_2 === this.hashCode_2))
          return false;
        return contentEquals(this.data_1, other.data_1);
      }
      hashCode() {
        var hc = this.hashCode_2;
        if (hc === 0) {
          hc = contentHashCode(this.data_1);
          this.hashCode_2 = hc;
        }
        return hc;
      }
      get_c1px32_k$(index) {
        if (index < 0 || index >= this.get_size_woubt6_k$())
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('index (' + index + ') is out of byte string bounds: [0..' + this.get_size_woubt6_k$() + ')');
        return this.data_1[index];
      }
      substring_d7lab3_k$(startIndex, endIndex) {
        var tmp;
        if (startIndex === endIndex) {
          tmp = Companion_getInstance().EMPTY_1;
        } else {
          tmp = ByteString().new_kotlinx_io_bytestring_ByteString_507kaj_k$(this.data_1, startIndex, endIndex);
        }
        return tmp;
      }
      substring$default_wq769b_k$(startIndex, endIndex, $super) {
        endIndex = endIndex === VOID ? this.get_size_woubt6_k$() : endIndex;
        return $super === VOID ? this.substring_d7lab3_k$(startIndex, endIndex) : $super.substring_d7lab3_k$.call(this, startIndex, endIndex);
      }
      compareTo_370sij_k$(other) {
        if (other === this)
          return 0;
        var localData = this.data_1;
        var otherData = other.data_1;
        var inductionVariable = 0;
        var tmp0 = this.get_size_woubt6_k$();
        // Inline function 'kotlin.math.min' call
        var b = other.get_size_woubt6_k$();
        var last = Math.min(tmp0, b);
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_0 = localData[i];
            var tmp0_0 = _UByte___init__impl__g9hnc4(this_0);
            // Inline function 'kotlin.toUByte' call
            var this_1 = otherData[i];
            // Inline function 'kotlin.UByte.compareTo' call
            var other_0 = _UByte___init__impl__g9hnc4(this_1);
            // Inline function 'kotlin.UByte.toInt' call
            var tmp = _UByte___get_data__impl__jof9qr(tmp0_0) & 255;
            // Inline function 'kotlin.UByte.toInt' call
            var tmp$ret$5 = _UByte___get_data__impl__jof9qr(other_0) & 255;
            var cmp = compareTo(tmp, tmp$ret$5);
            if (!(cmp === 0))
              return cmp;
          }
           while (inductionVariable < last);
        return compareTo(this.get_size_woubt6_k$(), other.get_size_woubt6_k$());
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_370sij_k$(other instanceof ByteString() ? other : THROW_CCE());
      }
      toString() {
        if (isEmpty(this)) {
          return 'ByteString(size=0)';
        }
        var sizeStr = this.get_size_woubt6_k$().toString();
        var len = (22 + sizeStr.length | 0) + imul(this.get_size_woubt6_k$(), 2) | 0;
        // Inline function 'kotlin.with' call
        var $this$with = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(len);
        $this$with.append_22ad7x_k$('ByteString(size=');
        $this$with.append_22ad7x_k$(sizeStr);
        $this$with.append_22ad7x_k$(' hex=');
        var localData = this.data_1;
        var inductionVariable = 0;
        var last = this.get_size_woubt6_k$();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var b = localData[i];
            $this$with.append_58al37_k$(Companion_getInstance().HEX_DIGITS_1[(b >>> 4 | 0) & 15]);
            $this$with.append_58al37_k$(Companion_getInstance().HEX_DIGITS_1[b & 15]);
          }
           while (inductionVariable < last);
        return $this$with.append_58al37_k$(_Char___init__impl__6a9atx(41)).toString();
      }
      getBackingArrayReference_x19ruh_k$() {
        return this.data_1;
      }
    }
    initMetadataForClass($, 'ByteString', VOID, VOID, [Comparable()]);
    ByteStringClass = $;
  }
  return ByteStringClass;
}
function ByteString_0(bytes) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (bytes.length === 0) {
    tmp = Companion_getInstance().EMPTY_1;
  } else {
    tmp = Companion_getInstance().wrap_yhiemk_k$(bytes);
  }
  return tmp;
}
function decodeToString_0(_this__u8e3s4) {
  return decodeToString(_this__u8e3s4.getBackingArrayReference_x19ruh_k$());
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.get_size_woubt6_k$() === 0;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3226yc45uduw8,
  ByteString_0 as ByteString3c9fk8lsh3lvs,
  ByteString as ByteString10sanmoo66key,
  decodeToString_0 as decodeToString2ede220pr5xir,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
